import { Component, OnInit, Directive, Pipe, PipeTransform, Input, HostBinding, HostListener, Injectable } from '@angular/core';
import { ActivatedRoute, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { ConfigService } from './config.service';
import { BrandingService, BrandInformation } from './branding.service';
import { Config } from './app.models';
import { startGtmScript } from './analytics.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'dollars' })
export class DollarsPipe implements PipeTransform {
  transform(value: number): number {
    return Math.trunc(value);
  }
}
@Pipe({ name: 'cents' })
export class CentsPipe implements PipeTransform {
  transform(value: number): string {
    return Math.trunc((value % 1) * 100).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
  }
}
@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    const m = value.match(/^(\d{3})?[- ]??[\s]?(\d{3})?[\s]?(\d{4})?(.*)?$/);
    if (m[1] !== undefined) {
      return '(' + m[1] + ') ' + m[2] + '-' + m[3];
    }
    return m[0];
  }
}
@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Directive({
  selector: '[phone]'
})
export class PhoneFormatDirective implements OnInit {
  @Input() phone: string;
  @HostBinding('value') phoneValue: string;

  constructor(private phonePipe: PhonePipe) { }

  ngOnInit() {
    this.phone = this.phone || '';
    this.format(this.phone);
  }
  @HostListener('change')
  format(value: string) {
    if (value.length === 10) {
      this.phoneValue = this.phonePipe.transform(value);
    }
  }
}

function parseQueryString(url): any {
  const params = {};
  let temp;

  const queries = url.substring(url.indexOf('?') + 1).split('&');

  for (let i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split('=');
    params[temp[0].toLowerCase()] = temp[1];
  }
  return params;
}

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const queryParams = parseQueryString(url);
    let newUrl = (window.location.pathname + '?source=' + queryParams.source).toLowerCase();
    if (queryParams.policyid !== undefined) {
      newUrl = newUrl + '&policyid=' + queryParams.policyid;
    }
    if (queryParams['carrier-logo'] !== undefined) {
      newUrl = newUrl + '&carrier-logo=' + queryParams['carrier-logo'];
    }
    if (queryParams.reason !== undefined) {
      newUrl = newUrl + '&reason=' + queryParams.reason.toLowerCase();
    }
    if (queryParams.productselected !== undefined) {
      newUrl = newUrl + '&productselected=' + queryParams.productselected.toLowerCase();
    }

    return super.parse(newUrl);
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private route: ActivatedRoute, private configSvc: ConfigService, private brandSvc: BrandingService) { }
  config: Config;
  brandInfo: BrandInformation;
  contactNumber: string;
  phone: string;
  gtmUrl: string;
  ngOnInit() {
    this.configSvc.getPolicyInfoConfig()
      .subscribe(config => {
        this.getBrandInfo(this.route.snapshot.queryParams.source, config.BrandInfoUrl);
        this.config = config;
      });
  }
  loadCss(fileName: string) {
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = fileName;
    cssLink.type = 'text/css';
    document.head.appendChild(cssLink);
  }
  getContactNumber(productSelected: string) {
    switch (productSelected) {
      case 'adb':
        return '833-460-1972';
    }
  }
  getGtmCode(productSelected: string) {
    if (productSelected === 'adb') {
      return environment.production ? 'GTM-5QPKL38' : 'GTM-N393QTG';
    }

    return this.brandInfo.GtmCode;
  }
  getBrandInfo(source: string, url: string) {
    this.brandSvc.getBrandingInformation(source, url)
      .subscribe((brandInfo: BrandInformation) => {
        this.brandInfo = brandInfo;
        this.contactNumber = this.getContactNumber(this.route.snapshot.queryParams.productselected) || brandInfo.PhoneNumber;
        const gtmCode = this.getGtmCode(this.route.snapshot.queryParams.productselected);
        startGtmScript(gtmCode);
        this.gtmUrl = 'https://www.googletagmanager.com/ns.html?id=' + gtmCode;
        this.loadCss(brandInfo.CssLocation);
      });
  }
}
